import { useRoutes } from "react-router-dom";


import NotFound from "../pages/redirect/NotFound";
import { MainRoutes } from "./MainRoutes";

export default function ThemeRoutes() {
  return useRoutes([
    // { path: "/admin", element: <Navigate to="/admin/board" replace /> },
    MainRoutes,
    { path: "*", element: <NotFound /> },
  ]);
}
